import React from 'react'

function CheckShield({ color }) {
  return (
    <>
      <svg className='checkShield' viewBox='0 0 22.505 27.545'>
        <path
          id={color}
          d='M 8.732505798339844 20.04373741149902 L 18.75437545776367 10.02186870574951 L 16.99615287780762 8.263645172119141 L 8.732505798339844 16.46868705749512 L 5.509098052978516 13.24527549743652 L 3.750874757766724 15.00349903106689 L 8.732505798339844 20.04373741149902 Z M 11.25262451171875 0 L 22.5052490234375 5.040237903594971 L 22.5052490234375 12.5419864654541 C 22.5052490234375 16.01937866210938 21.43078994750977 19.19391441345215 19.2818431854248 22.06568908691406 C 17.13289070129395 24.93746757507324 14.45651340484619 26.7640495300293 11.25262451171875 27.54548645019531 C 8.048736572265625 26.7640495300293 5.372357368469238 24.93746757507324 3.223408222198486 22.06568908691406 C 1.074458599090576 19.19391441345215 -4.034206568803711e-08 16.01937866210938 -4.034206568803711e-08 12.5419864654541 L -4.034206568803711e-08 5.040237903594971 L 11.25262451171875 0 Z'
        ></path>
      </svg>

      <style jsx>{`
        #checkShield-AA {
          fill: rgba(14, 119, 239, 1);
        }
        #checkShield-UA {
          fill: rgb(255, 69, 9);
        }
        .checkShield {
          overflow: visible;
          width: 22.505px;
          height: 27.546px;
          left: 0px;
          top: 1.727px;
          transform: matrix(1, 0, 0, 1, 0, 0);
        }
        @media (max-width: 1200px) {
          .checkShield {
            width: 16px;
          }
        }
      `}</style>
    </>
  )
}

export default CheckShield
